<template>
    <div class="statuses">
        <ValidationObserver ref="form" v-slot="{handleSubmit}">
            <form @submit.prevent="handleSubmit(send)">
                <vs-row>
                    <vs-col vs-w="12">
                        <div class="p-2">
                            <ValidationProvider vid="internal_status" :name="$t('global.Status')" rules="required" v-slot="{ errors }">
                                <label class="text-sm opacity-75">{{$t('global.Status')}}</label>
                                <v-select
                                    ref="select"
                                    :options="options.group_status"
                                    name="internal_status"
                                    :clearable="false"
                                    :placeholder="$t('global.Status')"
                                    autocomplete
                                    appendToBody
                                    v-model="selected.group_status"
                                    :calculate-position="withPopper"
                                />
                                <div class="text-danger text-xs" >{{ errors[0] }}</div>
                            </ValidationProvider>
                        </div>
                    </vs-col>
                    <vs-col vs-w="12">
                        <div class="p-2 text-right">
                            <vs-button button="submit" ref="btn">
                                {{ $t('buttons.Save') }}
                            </vs-button>
                        </div>
                    </vs-col>
                </vs-row>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import ErrorHandler from "@/utils/errorHandler"
import send from "@/utils/fetch"
import vSelect from "vue-select"
import {vSelectPosition} from "@/utils/mixins"
import EventBus from "@/store/eventBus";

export default {
    mixins: [vSelectPosition],
    props: ['popupData', 'popupType', 'popupButton'],

    components: {
        vSelect
    },

    data() {
        return {
            options: {
                group_status: []
            },
            selected: {
                group_status: null
            }
        }
    },

    methods: {
        async send() {
            await send(this.$url.statistic["group-status"], 'PATCH', {data: {
                    lead_ids: this.popupData,
                    ...this.selected
            }})

            EventBus.$emit('doneStatusMapping')
            EventBus.$emit('emitPopupEvent', {type: 'close'})
        },

        async getStatusMapping() {
            try {
                this.options.group_status = await send(this.$url.statistic['group-statuses'], 'GET')
                    .then(response => response.data.result)
                    .then(response => Array.from(new Set(response.map(item => item.internal_status))))
            } catch (e) {
                this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        await this.getStatusMapping()

        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
